const {
    DEFAULT_CHANNEL_FAMILY_ID,
    PREFIX_TOUCH,
    PREFIX_DESKTOP,
} = require('app/common/constants/stream');

/**
 * Возвращает stream для канала если familyId || channelId соответствует.
 * @param {Array} streamChannels каналы из ручки видеохостинга.
 * @param {Number} id familyId || channelId канала.
 * @param {Boolean} [isCheckChannelId] для обратной совместимости проверка на соответствие id канала.
 * @returns {Object|null}
 */
function getStreamChannel(streamChannels = [], id, isCheckChannelId) {
    return streamChannels.filter(channel => {
        const idToCheck = isCheckChannelId ? channel.id : channel.familyId;

        return idToCheck === id;
    })[0] || null;
}

/**
 * Для каналов у которых нет stream, возвращает stream Первого канала по его familyId
 * и если его не находит, то возвращает первый stream из списка каналов из ручки
 * @param {Array} streamChannels каналы из ручки видеохостинга.
 * @returns {Object}
 */
function getStreamDefaultChannel(streamChannels = []) {
    return streamChannels.filter(stream => DEFAULT_CHANNEL_FAMILY_ID === stream.familyId)[0]
    || streamChannels[0];
}

/**
 * Когда кнопка онлайн выводится для передачи, нужно проверять, действительно ли она сейчас идет
 * @param {Array} streamChannels каналы из ручки видеохостинга.
 * @param {Number} channelId канала.
 * @returns {Boolean}
 */
function isRelevantStream(streamChannels = [], channelId) {
    return streamChannels.some(streamChannel => streamChannel.id === channelId);
}

/**
 * Строит строку для параметра FromBlock, нужного для Яндекс статистики видео смотрения
 * @param {String} location откуда вызывается данный блок.
 * @param {Boolean} isTouchPhone
 * @returns {String}
 */
function buildYStatFromBlock(location, isTouchPhone) {
    const regex = new RegExp(`^${PREFIX_DESKTOP}|${PREFIX_TOUCH}`);
    const prefix = !regex.test(location)
        ? isTouchPhone ? PREFIX_TOUCH : PREFIX_DESKTOP
        : '';

    return `${prefix}${decodeURIComponent(location)}`;
}

module.exports = {
    getStreamChannel,
    getStreamDefaultChannel,
    isRelevantStream,
    buildYStatFromBlock,
};
